<template>
    <b-container>

        <div v-if="validatorKey">

            <h1>{{ validatorData.name }}: Solana Staking Statistics, APY, Rewards + History</h1>
        </div>
        <div v-else><h1>Solana Staking Statistics: Track Total Stake, Average Sizes + History</h1>
            <p class="lead mt-3">Explore the Solana staking ecosystem. See how stake has grown over time, what is being staked or unstaked, average stake sizes and historic yield</p>

        </div>


        <div class=" text-center  ">
            <div><p class="font-weight-semibold">Jump to:</p>
                <a class="btn btn-pill btn-primary  mr-2 ml-2" href="#profile" v-if="validatorKey">Validator Profile</a>
                <a class="btn btn-pill btn-primary mr-2" href="#economy">Statistics</a>
                <a class="btn btn-pill btn-primary mr-2" href="#list" v-if="!validatorKey">Validator List</a>
                <a class="btn btn-pill btn-primary   mr-2" href="#stakes">Stake Distribution</a>
                <a class="btn btn-pill btn-primary   mr-2" href="#epoch">Epoch History</a>
                <a class="btn btn-pill btn-primary   mr-2" href="#page-content" v-if="!validatorKey">How To Choose</a>

                <!--<a class="btn btn-pill btn-primary btn-sm mr-2" href="#decentralization" v-if="!validatorData">Network Decentralization</a>-->
            </div>
        </div>
        <div class="row" v-if="validatorKey">
            <h3 id="profile">Validator Profile</h3>
            <b-alert variant="danger" v-if="validatorData.d.delinquent">This validator is currently delinquent. No
                rewards are being generated as their server is not generating blocks
            </b-alert>
            <div class="card">
                <div class="row">

                    <div class="col-sm-3">
                        <img :src="validatorData.icon" class="brround">
                    </div>
                    <div class="col-sm-2 text-center order-md-3">
                        <h1 class="mb-0 mt-5">
                            <span
                                :class="{'text-success': data.score.score > 0.85, 'text-warning': data.score.score > 0.5 && data.score.score < 0.85, 'text-danger': data.score.score < 0.5}">
                                {{ (data.score.score_percent).toFixed(1) }}%
                            </span>
                        </h1>
                        <p class="text-muted small">Compass Score<br><small>last 5 epochs</small></p>
                        <a :href="'/staking#delegate/'+validatorKey" @click="trackDelegate" class="btn btn-success btn-lg btn-xl"
                           v-if="data.score.score>.6">Delegate Stake</a>
                        <a href="/validators" class="btn btn-danger btn-lg btn-xl" v-else>Find Alternative</a>
                        <a :href="'/staking'" class="btn btn-outline-info w-100 my-3">Staking App</a>
                        <a :href="validatorData.www_url" target="_blank" v-if="validatorData.www_url" class="small">Visit
                            Website</a>

                    </div>
                    <div class="col-sm">
                        <b-list-group>

                            <h3>{{ validatorData.name }}</h3>
                            <h4>
                                <ul class="list-inline">
                                    <li class="list-inline-item" v-for="flag in data.score.flags" :key="flag">
                                          <span :class="'badge p-2 ' + getBadgeType(flag)">
                                            <i :class="icon(flag)"></i> {{ formatKey(flag) }}
                                              <span v-if="flag == 'JITO_ME1V'" class="small">
                                                  ({{ (validatorData.jito_commission/100).toFixed(1) }}%)
                                              </span>
                                          </span>
                                    </li>
                                </ul>
                            </h4>

                            <p class="lead" v-if="validatorData.d.details">{{ validatorData.d.details }}</p>
                            <p class="lead " v-else>This validator has not taken the time to write a
                                description for stakers 🤷‍ </p>
                            <h4>Stake now:</h4>
                            <delegate-stake :name="validatorData.name" :vote="validatorData.d.vote_account" :score="(data.score.score*100).toFixed(2)"></delegate-stake>


                            <b-tabs pills class="mt-3">
                                <b-tab title="Score" class="mt-3">
                                    <validator-score :validator="data.score" v-if="data.score.score"></validator-score>
                                </b-tab>
                                <b-tab title="Public Keys" class="mt-3">
                                    <b-list-group-item>
                                        <strong>Vote Account:</strong>
                                        <pre
                                            class="float-right text-light bg-dark p2">{{ validatorData.d.vote_account }}</pre>
                                    </b-list-group-item>
                                    <b-list-group-item>
                                        <strong>Identity:</strong>
                                        <pre
                                            class="float-right text-light bg-dark p2">{{ validatorData.d.account }}</pre>
                                    </b-list-group-item>

                                </b-tab>
                            </b-tabs>

                        </b-list-group>
                    </div>

                </div>
                <hr>
                <b-row v-if="validatorKey">
                    <div class="col p-3">
                        <h3>Should You Stake With {{ validatorData.name }}?</h3>

                        <div class="lead">
                            <b-row v-if="data.stats.total < (1000000 / lamsol)" class="text-success m-5">
                                <div class="col-1 text-center">

                                    <b-icon icon="check-circle" scale="2" class="mr-5" variant="success"></b-icon>
                                </div>
                                <div class="col">

                                    <span
                                        class="ml-5">This validator has a low share of stake, aiding decentralization</span>
                                </div>
                            </b-row>
                            <b-row v-else class="text-warning m-5">
                                <div class="col-1 text-center">

                                    <b-icon icon="exclamation-triangle-fill" scale="2" class="mr-5"
                                            variant="warning"></b-icon>
                                </div>
                                <div class="col">

                                    <span class="ml-5">This validator has a high share of stake - you should stake elsewhere to help secure the network</span>
                                </div>
                            </b-row>

                            <b-row v-if="validatorData.apy > (filterAPY/100)" class="text-success m-5">
                                <div class="col-1 text-center">

                                    <b-icon icon="check-circle" scale="2" class="mr-5" variant="success"></b-icon>
                                </div>
                                <div class="col">
                                    <span class="ml-5">This validator has a decent average APY and good returns</span>
                                </div>
                            </b-row>
                            <b-row v-else class="text-warning m-5">
                                <div class="col-1 text-center">
                                    <b-icon icon="exclamation-triangle-fill" scale="2" class="mr-5"
                                            variant="warning"></b-icon>
                                </div>
                                <div class="col">

                                    <span class="ml-5">This validator has a low average APY  due to a high commission or low reliability. You should look to stake elsewhere</span>
                                </div>
                            </b-row>

                            <b-row v-if="validatorData.d.data_center_concentration_score > -2" class="text-success m-5">

                                <div class="col-1 text-center">
                                    <b-icon icon="check-circle" scale="2" class="mr-5" variant="success"></b-icon>
                                </div>
                                <div class="col">
                                    <span class="ml-5">This validator's servers are in a datacenter with low stake concentration, aiding decentralization</span>
                                </div>
                            </b-row>
                            <b-row v-else class="text-warning m-5">

                                <div class="col-1 text-center">
                                    <b-icon icon="exclamation-triangle-fill" scale="2" class="mr-5"
                                            variant="warning"></b-icon>
                                </div>
                                <div class="col">
                                    <span class="ml-5">This validator is based in a datacenter with a high concentration of stake, which hurts decentralization. Please try to stake elsewhere.</span>
                                </div>
                            </b-row>

                            <div style="color: #666;" class="alert alert-light-success text-black text-center"><strong>Like
                                Solana Compass?</strong> Stake with us and earn a high APY while supporting our site
                                <a href="/our-validator" class="btn btn-info ml-3" style="margin-left: 18px;">Stake
                                    Now</a></div>

                        </div>
                    </div>
                </b-row>
                <hr>
                <div class="row mt-3" v-if="loaded">
                    <div class="col-sm  text-center" style="border-right:1px solid #e0e0e0;">
                        <h3>{{ (validatorData.apy*100).toFixed(1) }}%</h3>
                        <p class="lead text-uppercase">APY</p>
                    </div>
                  <div class="col-sm  text-center" style="border-right:1px solid #E0E0E0;">
                        <h3>{{ validatorData.d.commission }}%</h3>
                        <p class="lead text-uppercase">Commission</p>
                    </div>
                    <div class="col-sm text-center" style="border-right:1px solid #E0E0E0;">
                        <h3>{{ (validatorData.d.skipped_slot_percent * 100).toFixed(1) }}%</h3>
                        <p class="lead text-uppercase">Skipped Slot %</p>
                    </div>
                    <div class="col-sm text-center" style="border-right:1px solid #E0E0E0;">
                        <h3>{{ validatorData.d.data_center_key.split('-')[1] }}</h3>
                        <p class="lead text-uppercase">Datacenter Country</p>
                    </div>
                    <div class="col-sm text-center" style="border-right:1px solid #E0E0E0;">
                        <h3>{{ validatorData.d.data_center_key.split('-')[2].toUpperCase() }}</h3>
                        <p class="lead text-uppercase">Datacenter City</p>
                    </div>
                    <div class="col-sm  text-center">
                        <h3 v-if=" validatorData.d.data_center_concentration_score > -2">OK</h3>
                        <h3 v-if=" validatorData.d.data_center_concentration_score < -1">Over Centralized</h3>
                        <p class="lead text-uppercase">Datacenter Centralization</p>
                    </div>


                </div>
            </div>
        </div>


        <h2 id="economy">Staking Statistics</h2>
        <b-row class="justify-content-between">
            <b-col sm="auto" v-b-tooltip.hover
                   title="The total number of Solana currently staked on Solana's network of validators">
                <b-card>
                    <p class="mb-1">Total Staked</p>
                    <h3 class="mb-1" title="SOL">{{ formatsol(data.stats.total) }}</h3>
                    <p class="">{{ formatusd(data.stats.total) }}</p>
                </b-card>
            </b-col>
            <b-col sm="auto" v-b-tooltip.hover
                   title="The total number of active stake accounts. The majority of wallets only have one stake account, so this is a rough indication of the number of individuals staking.">
                <b-card>
                    <p class="mb-1">Active Stakers</p>
                    <h3 class="mb-1">{{ data.stats.num_active }}</h3>
                    <p class="">Unique stakes</p>
                </b-card>
            </b-col>

            <b-col sm="auto" v-b-tooltip.hover
                   title="The number of unique wallets discovered, as indicated by the withdrawal authority - the wallet with the right to withdraw the stake - set on each stake account.">
                <b-card>
                    <p class="mb-1">Unique Wallets</p>
                    <h3 class="mb-1">{{ data.stats.wallets || '' }}</h3>
                    <p class="">&nbsp;</p>
                </b-card>
            </b-col>

            <b-col sm="auto" v-b-tooltip.hover
                   title="The biggest single stake delegated to a validator on Solana's network">
                <b-card>
                    <p class="mb-1">Biggest Stake</p>
                    <h3 class="mb-1" title="SOL">{{ formatsol(data.stats.max) }}</h3>
                    <p class="">{{ formatusd(data.stats.max) }}</p>
                </b-card>
            </b-col>
            <b-col sm="auto" v-b-tooltip.hover
                   title="The median stake is the midpoint between the highest and lowest stakes. It's more helpful than a mean average here as it treats 'whales' with huge stakes as the outliers they are.">
                <b-card>
                    <p class="mb-1">Median Stake</p>
                    <h3 class="mb-1" title="SOL">{{ formatsol(data.stats.median, 2) }}</h3>
                    <p class="">{{ formatusd(data.stats.median) }}</p>
                </b-card>
            </b-col>
            <b-col sm="auto" v-b-tooltip.hover
                   title="The mean is the average stake across all stake accounts. This skews high due to a small number of massive 'whale' accounts staking on Solana.">
                <b-card>
                    <p class="mb-1">Mean Stake</p>
                    <h3 class="mb-1" title="SOL">{{ formatsol(data.stats.mean, 2) }}</h3>
                    <p class="">{{ formatusd(data.stats.mean) }}</p>
                </b-card>
            </b-col>
        </b-row>

        <!--        <h3>Global Distribution</h3>
                <b-row>
                    <b-card>
                        <geo-chart :data="data.geo[0]['data']" :library="{
                displayMode: 'markers',
                colorAxis: {colors: ['green', 'blue']}
              }
        "></geo-chart>
                    </b-card>
                </b-row>-->

        <h3>Stake Growth Over Time</h3>
        <b-card>
            <b-tabs pills v-if="loaded">
                <b-tab title="All Time" class="pt-3">
                    <line-chart
                        :data="[{name:'Total Staked', data: data.epochCharts.balance.data, dataset: { borderWidth: 1} }]"
                        :library="{
  scales: {
    yAxes: [{
      display:true
    }]
  },
}"
                        :axis="false" :legend="false"></line-chart>
                </b-tab>
                <b-tab title="~60 Days" class="pt-3">
                    <line-chart
                        :data="[{name:'Total Staked', data: data.epochCharts.last?.data || [], dataset: { borderWidth: 1} }]"
                        :min="data.epochCharts.last?.min || 0"
                        :library="{
  scales: {
    yAxes: [{
      display:true
    }]
  },
}"
                        :axis="false" :legend="false"></line-chart>
                </b-tab>
            </b-tabs>
            <div class="small text-center text-muted mt-2">
                Due to issues with missing data, epochs 304,346 and 355 have been removed from the chart and the below
                tables
            </div>


        </b-card>

        <hr>

        <b-row>
            <b-col sm="6">
                <h1>New / Lost Stake Prev 20 Epochs</h1>
                <b-card>
                    <column-chart :stacked="true" :data="[
            data.epochCharts?.activated || {name:'Activated', data:[]},
            data.epochCharts?.deactivated || {name: 'Deactivated', data: []}
            ]"
                                  :library="{
  scales: {
    yAxes: [{
      display:true
    }]
  },
}"
                                  :axis="false" :legend="false"
                    ></column-chart>
                </b-card>
            </b-col>
            <b-col sm="6">
                <h1>New / Lost Stake So Far This Epoch</h1>
                <b-row>

                    <b-card>
                        <p class="mb-1">Change this Epoch</p>
                        <b-row class="mb-5">
                            <b-col class="col-sm-4">
                                <h4 class="mb-1">Activating Stake</h4>
                                {{ formatsol(data.stats.activating) }}
                                ({{ (data.stats.activating / data.stats.total * 100).toFixed(2) }} %)
                            </b-col>

                            <b-col sm class="mr-2" style="height:52px;">
                                <b-progress-bar :value="data.stats.activating" class="dash2"
                                                :title="formatsol(data.stats.activating) + ' / ' + formatusd(data.stats.activating)"
                                                v-b-tooltip:hover variant="success" style="height:50px"
                                                :max="Math.max(data.stats.activating, data.stats.deactivating) *1.2 "></b-progress-bar>
                            </b-col>
                        </b-row>
                        <b-row class="mt-5 mb-5">
                            <b-col class="col-sm-4">
                                <h4 class="mb-1">Deactivating Stake</h4>
                                {{ formatsol(data.stats.deactivating) }}
                                ({{ (data.stats.deactivating / data.stats.total * 100).toFixed(2) }} %)
                            </b-col>
                            <b-col sm class="mr-2" style="height:52px;">
                                <b-progress-bar :value="data.stats.deactivating" class=dash3
                                                :title="formatsol(data.stats.deactivating) + ' / ' + formatusd(data.stats.deactivating)"
                                                v-b-tooltip:hover variant="danger" style="height:50px"
                                                :max="Math.max(data.stats.activating, data.stats.deactivating)*1.2"></b-progress-bar>
                            </b-col>
                        </b-row>
                        <b-row class="mt-5">
                            <b-col class="col-sm-4">
                                <h4 class="mb-1">Net Change</h4>
                                {{ formatsol(data.stats.activating - data.stats.deactivating) }} ({{
                                    ((data.stats.activating - data.stats.deactivating) / data.stats.total * 100).toFixed(2)
                                }} %)
                            </b-col>
                            <b-col sm class="mr-2 " style="height:52px;">
                                <b-progress-bar :value="Math.abs(data.stats.activating - data.stats.deactivating)"
                                                :class="{ 'dash4' : (data.stats.activating - data.stats.deactivating) >= 0, 'bg-gradient-danger' : (data.stats.activating - data.stats.deactivating) < 0 }"
                                                :title="formatsol(data.stats.activating - data.stats.deactivating) + ' / ' + formatusd(data.stats.activating - data.stats.deactivating)"
                                                v-b-tooltip:hover variant="primary" style="height:50px"
                                                :max="Math.max(data.stats.activating, data.stats.deactivating)*1.2"></b-progress-bar>
                            </b-col>
                        </b-row>
                        <b-row>
                            <div class="mt-4 ">
                                Want to know what stake moved, and where? See our new <a href="/statistics/staking/change">stake
                                change insights</a>
                            </div>

                            <small class="mt-1">Note: This epoch is incomplete and figures are subject to change. Stake
                                pools are excluded by default, for a full breakdown please visit the stake change page
                                above. We update our figures every 15 mins to give an accurate picture of the inflows
                                and outflows from Solana's staking economy</small>
                        </b-row>
                    </b-card>
                </b-row>
            </b-col>

        </b-row>


        <hr>
        <b-row v-if="validatorKey">
            <h2 id="Performance">Validator Performance</h2>
            <b-card>
                <h4>Epoch Performance Data</h4>
                Want to see how today's performance compares to previous epochs?
                <b-tabs pills>
                    <b-tab title="Compute Units">
                        <line-chart :data="[
                            {
            'name':'Validator Avg Compute Units Per Block  (million)',
                        'data':data.performance.where('leader',data.validator_id).pluck('cu','epoch').items
                        },
                           {
            'name':'Cluster Avg Compute Units Per Block  (million)',
                        'data':data.performance.where('leader',null).pluck('cu','epoch').items
                        }
                        ]" title="Avg Compute Units Per Block  (million)"></line-chart>
                    </b-tab>

                    <b-tab title="Block Size">
                        <line-chart :data="[{
            'name':'Validator Average Txns/Slot',
                        'data': data.performance.where('leader',data.validator_id).pluck('txns','epoch').items
                        },
                        {
                            'name':'Cluster Average Txns/Slot',
                             'data': data.performance.where('leader',null).pluck('txns','epoch').items
                        }
                        ]" title="Average Block Size (transactions per block)"></line-chart>
                    </b-tab>
                    <b-tab title="Slot Skip Rate">
                        <line-chart :data="[{
            'name':'Validator Skipped Slots',
                        'data': data.performance.where('leader',data.validator_id).map((val) => {
                            if (val.num_slots > 0) val.skipped_percent = (val.skipped / val.num_slots * 100).toFixed(2)
                            return val
                        }).pluck('skipped_percent','epoch').items
                        },{
            'name':'Cluster Skipped Slots',
                        'data': data.performance.where('leader',null).map((val) => {
                            if (val.num_slots > 0) val.skipped_percent = (val.skipped / val.num_slots * 100).toFixed(2)
                            return val
                        }).pluck('skipped_percent','epoch').items
                        }]" title="Cluster Skipped Slot Percent"></line-chart>
                    </b-tab>
                    <b-tab title="Avg Rewards">
                        <column-chart :data="[{
                            'name':'Validator Avg Rewards',
                            'data': data.performance.where('leader',data.validator_id).pluck('avg_rewards','epoch').items
                        },{
                            'name':'Cluster Avg Rewards',
                            'data': data.performance.where('leader',null).pluck('avg_rewards','epoch').items
                        }]" title="Average Epoch Block Rewards (in lamports)"></column-chart>
                    </b-tab>
                    <b-tab title="Table">
                        <b-table :items="data.performance.items"
                                 responsive
                                 :fields="[
                {key:'epoch', label: 'Epoch', sortable:true},
                {key:'leader', label: 'Leader', sortable:true},
                {key:'avg_rewards', label: 'Avg Block Rewards', sortable: true},
                {key:'median_rewards', label: 'Median Rewards', sortable: true},
                {key:'num_slots', label:'Slots'},
                {key:'skipped_percent', label:'Skipped (%)'},
                {key:'txns',label:'Average Txns/Slot'},
                {key:'non_vote_txns',label:'Average User Tx/Slot'},
                {key:'priority_fees',label:'Total Priority Fees'},
                {key:'failed',label:'Average Failed/Slot'},
                {key:'cu',label:'Avg Compute Units (m)'},
                ]"
                        >

                            <template v-slot:cell(avg_rewards)="data" >
                                {{ (data.item.avg_rewards / 1e9).toFixed(5) }} ◎
                            </template>
                            <template v-slot:cell(median_rewards)="data" >
                                {{ (data.item.median_rewards / 1e9).toFixed(5) }} ◎
                            </template>

                            <template v-slot:cell(leader)="data">
                                <span v-if="!data.item.leader">Epoch Average</span>
                                <span v-else>{{ validatorData.name || validatorKey }}</span>
                            </template>
                            <template v-slot:cell(skipped_percent)="data">
                                {{ Number(data.item.skipped/data.item.num_slots*100).toFixed(2) }} %
                            </template>
                            <template v-slot:cell(cu)="data">
                                {{ (data.item.cu / 1e6).toFixed(1) }}m
                            </template>
                            <template v-slot:cell(priority_fees)="data">
                                {{ (data.item.priority_fees / 1e9).toFixed(2) }} ◎
                            </template>

                        </b-table>

                        <small>All figures are shown as an average per slot for that epoch.</small>
                    </b-tab>
                </b-tabs>
            </b-card>
        </b-row>
<!--
        <div v-if="!validatorKey">

            <h2 id="list">Top Validators By Performance

            </h2>
            &lt;!&ndash;            <p class="lead">We've deliberately filtered this list to show high performing, smaller validators to improve decentralization and censorship resistance. Want to see every validator? Simply click clear filters below!</p>&ndash;&gt;

            <div style="color: #666;" class="alert alert-light-success text-black text-center"><strong>Like Solana
                Compass?</strong> Stake with us and earn a high APY while supporting our site
                <a href="/our-validator" class="btn btn-info ml-3" style="margin-left: 18px;">Stake Now</a></div>
            <b-card>

                &lt;!&ndash;                <b-row>
                                    <b-col sm="auto">



                                        <label class="font-weight-semibold">Search By Name
                                            <b-form-group>
                                                <b-form-input type="text" v-model="filterName" placeholder="Search">
                                                </b-form-input>

                                            </b-form-group>
                                        </label>
                                    </b-col>
                                    <b-col sm="auto">
                                        <label class="font-weight-semibold">Active Stake Below:
                                            <b-form-input type="number" min="0" max="10000000"  step="50000" v-model="filterStake">
                                            </b-form-input>
                                        </label>
                                    </b-col>

                                    <b-col sm="auto">
                                        <label class="font-weight-semibold">Minimum APY:
                                            <b-form-input type="number" min="0" max="15"  step="0.1" v-model="filterAPY">
                                            </b-form-input>
                                        </label>
                                    </b-col>
                                    <b-col sm="auto">
                                        <label class="font-weight-semibold">Named Validators
                                            <b-form-checkbox v-model="filterHasName" class="pl-1 small mt-1"><span class="ml-4">Has Name Only</span></b-form-checkbox>
                                        </label>
                                    </b-col>
                                    <b-col sm="auto" class="text-right">
                                        <label>
                                            <br>
                                            <b-button variant="info" @click="showAllValidators">Clear Filters</b-button>
                                        </label>
                                    </b-col>



                                </b-row>&ndash;&gt;
                <b-table :responsive="true" card per-page="50" :items="Object.values(data.validators_table)"
                         :fields="[
                         {key:'name',label:'Name', sortable:true},
                         {key:'apy',label:'Average Return', sortable: true, sortDirection:'desc'},
                         {key:'total',label:'Active Stake', sortable:true},
                         {key:'count',label:'Stake Accounts', sortable:true},
                         {key:'wallets',label:'Unique Wallets', sortable:true},
                         {key:'median',label:'Median Stake', sortable:true},
                         {key:'net_last_period',label:'Change (Last 10 Epochs)', sortable:true},
                     ]"
                         sort-by="apy" :sort-desc="true"
                         :filter-function="filterValidators"
                         :current-page="validatorsCurrentPage"
                         @filtered="tableFiltered"
                >
                    <template #cell(name)="row">
                        <div class="row">
                            <div class="col-sm-1 align-middle">
                                <img :src="row.item.icon" v-if="row.item.icon" style="max-width:30px" class="brround">
                            </div>
                            <div class="col-sm">
                                <a :href="'/validators/'+row.item.key">{{ row.item.name }}</a>
                                <br>
                                <small class="text-muted">{{ row.item.key }}</small>
                            </div>
                        </div>
                    </template>
                    <template #cell(apy)="row">
                        {{ (row.item.apy * 100).toFixed(2) }}%
                    </template>
                    <template #cell(commission)="row">
                        {{ row.item.commission }}%
                    </template>
                    <template #cell(total)="row">
                        {{ formatsol(row.item.total) }}
                    </template>
                    <template #cell(count)="row">
                        {{ row.item.count.toLocaleString() }}
                    </template>
                    <template #cell(median)="row">
                        {{ formatsol(row.item.median, 1) }}
                    </template>
                    <template #cell(net_last_period)="row">

                        {{ formatsol(row.item.net_last_period) }}
                        &lt;!&ndash; <column-chart :stacked="true" style='height:75px'
                                     :data="[ {name:'Activating', data:row.item.activations} , {name:'Deactivating', data:row.item.deactivations} ]"
                                     :library="{
   scales: {
     yAxes: [{
       display:false
     }],
     xAxes: [{
       display:false
     }],
   },
 }"
                                     :axis="false" :legend="false">
                         </column-chart>&ndash;&gt;
                    </template>
                </b-table>
                <b-pagination v-model="validatorsCurrentPage" :total-rows="validatorsRows"
                              :current-page="validatorsCurrentPage" per-page="50"
                              first-class="bg-dark text-white" last-class="bg-dark text-white"
                              page-class="bg-dark text-white" prev-class="bg-dark text-white"
                              next-class="bg-dark text-white" ellipsis-class="bg-dark text-white"

                ></b-pagination>

                <small>Thanks to validators.app and stakeview.app for enriching our validator data with names, avatars
                    and average returns data</small>
            </b-card>
        </div>
-->

        <h2 id="performance">Historic Performance (APY)</h2>

        <div class="card" v-if="loaded">
            <line-chart v-if="validatorKey" :data="[
                   data.epochCharts.validatorAPY,
                   data.epochCharts.bestAPY,
                   data.epochCharts.avgAPY
            ]" :colors="['#4eb3d3','#2b8cbe','#0868ac']"></line-chart>
            <line-chart v-else :data="[
                   data.epochCharts.bestAPY,
                   data.epochCharts.avgAPY
            ]" :colors="['#4eb3d3','#0868ac']"></line-chart>
        </div>


        <h2 id="stakes">Average Stake Sizes

        </h2>
        <b-card>
            <b-table card :responsive="true" :items="data.stake_amounts" :fields="[
            { key:'from', label:'SOL Staked', sortable:true, tdClass:'text-center', thClass:'text-center'},
            { key:'sum', label:'Total Staked', sortable:true},
            { key:'num_stakes', label:'Num Stake Accounts', sortable:true, tdClass:'text-right', thClass:'text-right'},
            { key:'wallets', label:'Unique Wallets', sortable:true, tdClass:'text-right', thClass:'text-right'},
            { key:'med', label:'Median Stake', sortable:true, tdClass:'text-right', thClass:'text-right'},
            { key:'unique_validators', label:'Unique Validators', sortable:true, tdClass:'text-right', thClass:'text-right'}
        ]">
                <template #cell(from)="row">
                    {{ row.item['from'].toLocaleString() }} - {{ row.item['to'].toLocaleString() }}
                </template>
                <template #cell(num_stakes)="row">
                    {{ row.item.num_stakes.toLocaleString() }}
                </template>
                <template #cell(med)="row">
                    {{ formatsol(row.item.med, 2) }}
                </template>
                <template #cell(unique_validators)="row">
                    {{ row.item.unique_validators.toLocaleString() }}
                    <b-progress variant="success" c='d-block text-right' :max="1200"
                                :value="row.item.unique_validators"
                                style="height:5px; direction: rtl !important;"></b-progress>
                </template>
                <template #cell(sum)="row">
                    {{ formatsol(row.item.sum) }}
                    <small>({{ (row.item.sum / data.stats.total * 100).toFixed(2) }}%) </small>
                    <b-progress variant="danger" :max="36"
                                :value="row.item.sum / data.stats.total *100" style="height:5px"></b-progress>
                </template>
            </b-table>

        </b-card>


        <hr>

        <!--
                <h2 id="decentralization">Decentralization & Network Health</h2>

                <b-card>
                    <b-list-group>
                        <b-list-group-item>
                            Total validators
                            <span class="float-right font-weight-bold">{{ validators.count() }}</span>
                        </b-list-group-item>
                        <b-list-group-item v-b-tooltip:hover="Delinquent validators are no longer producting stake rewards due to downtime or technical issues">
                            Delinquent validators
                            <span class="float-right font-weight-bold">{{ validators.where('d.delinquent',true).count() }}</span>
                        </b-list-group-item>
                    </b-list-group>
                </b-card>
        -->

        <h2 id="epoch">Epoch History

        </h2>

        <b-card>
            <b-table :responsive="true" :items="Object.values(data.epochTrends)"
                     :fields="[
                {key:'start', label:'Date'},
                {key:'epoch', sortable:true, sortDirection:'desc', label:'Epoch'},
                {key:'activated', sortable:true, label:'Activated Stake'},
                {key:'activated_count', sortable:true, label:'# Stakes Activated'},
                {key:'activated_median', sortable:true, label:'Avg Stake Activated'},
                {key:'deactivated', sortable:true, label:'Deactivated Stake'},
                {key:'deactivated_count', sortable:true, label:'# Stakes Deactivated'},
                {key:'deactivated_median', sortable:true, label:'Avg Stake Deactivated'},
                {key:'balance',sortable:true}

            ]" tbody-tr-class="text-right" hover


                     sort-by="epoch" :sort-desc="true"
            >
                <template #cell(activated)="row">
                    {{ formatsol(row.item['activated'], 1) }}
                </template>
                <template #cell(deactivated)="row">
                    {{ formatsol(row.item['deactivated'], 1) }}
                </template>
                <template #cell(activated_median)="row">
                    {{ formatsol(row.item.activated_median, 1) }}
                </template>
                <template #cell(deactivated_median)="row">
                    {{ formatsol(row.item.deactivated_median, 1) }}
                </template>
                <template #cell(balance)="row">
                    {{ formatsol(row.item.balance, 1) }}
                </template>


            </b-table>
        </b-card>

        <hr>
    </b-container>
</template>

<script>
// import Vue from 'vue'
// import Chartkick from 'vue-chartkick'
// import Chart from 'chart.js'
import collect from 'collect.js'
import ValidatorScore from "./Validators/ValidatorScore.vue";
import DelegateStake from "./Delegate.vue";
// import JsonCSV from 'vue-json-csv'

// Vue.use(Chartkick.use(Chart))


// Chartkick.configure({language: "en", mapsApiKey: 'AIzaSyCq0AyegvZT6GQImemrR4NWUnSaT6VqWlQ'})

export default {
    name: "StakeEconomy",
    components: {DelegateStake, ValidatorScore},
    // components: { 'downloadCsv': JsonCSV },
    data() {
        return {
            data: {
                stats: {},
                epochCharts: {
                    balance: {data: []},

                },
                validators_table: [],
                epochTrends: [],
                geo: [],
                performance: collect(),
                score: {
                    score: 0,
                }
            },
            solusd: 0,
            gecko: {},
            lamsol: 1 / 1000000000,
            filterName: '',
            filterStake: 350000,
            filterAPY: 6.6,
            filterHasName: true,
            validatorKey: null,
            validatorData: {
                name: '',
                icon: '',
                d: {
                    details: '',
                    data_center_concentration_score: 0,
                    skipped_slot_percent: 0,
                    commission: 0,
                    data_center_key: 0
                },
                apy: 0,
            },
            validatorsCurrentPage: 1,
            validatorsRows: 0,
            loaded: false,
        }
    },
    props: ['validator'],
    mounted() {
        if (this.validator != null) this.validatorKey = this.validator
        else if (window.location.search.length > 10) {
            this.validatorKey = window.location.search.replace('?validator=', '')
        }
        fetch('https://api.coingecko.com/api/v3/coins/solana').then(r => r.json()).then((data) => {
            console.log(data)
            this.gecko = data
            this.solusd = this.gecko.tickers[0].last

        })
        if (this.validatorKey != null) var queryString = '?validator=' + this.validatorKey
        else var queryString = ''
        axios.get('/stats' + queryString).then((res) => {
            this.data = res.data
            this.loaded = true
            console.log(this.data)
            this.data.performance = collect(this.data.performance)

            if (this.validatorKey != null) {
                this.data.validators_table.forEach((val) => {
                    if (val.key == this.validatorKey) this.validatorData = val
                })
            }
            // calculate the average APY and create a filter value
            var apy = collect(Object.values(this.data.epochCharts.avgAPY.data).slice(-5)).avg()
            console.log('apy', apy)
            // Be at least 5% better than avg
            this.filterAPY = (apy * 1.05).toFixed(2)
        })
    },
    methods: {
        formatusd(val) {
            let formatter = new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: 'USD',

                // These options are needed to round to whole numbers if that's what you want.
                //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
                maximumFractionDigits: 2, // (causes 2500.99 to be printed as $2,501)
            })
            return formatter.format(val * this.lamsol * this.solusd)
        },
        formatsol(val, digits = 0) {
            let formatter = new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: 'USD',

                // These options are needed to round to whole numbers if that's what you want.
                minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
                maximumFractionDigits: digits, // (causes 2500.99 to be printed as $2,501)
            })
            return formatter.format(val * this.lamsol).replace('$', '◎')
        },
        filterValidators(row) {
            // console.log('tow',row)
            this.validatorsCurrentPage=1;
            if (this.filterHasName && row.name.length < 1) return false
            if (!row.name.toLowerCase().includes(this.filterName.toLowerCase())) {
                // console.log('name doesn\'t match')
                return false
            }
            if ((row.total * this.lamsol) > this.filterStake) {
                // console.log('stake too high', (row.total * this.lamsol), this.filterStake)
                return false
            }
            if (Math.round(row.apy * 1000) < (this.filterAPY * 10)) {
                // console.log('apy too low', this.filterAPY*10,row.apy*1000)
                return false
            }
            return true
        },
        tableFiltered(rows, numRows) {
            this.validatorsRows = numRows
        },
        showAllValidators() {
            this.filterName = ''
            this.filterAPY = 0
            this.filterStake = 25000000
        },
        formatKey(key) {
            key= key.replace(/([a-z])([A-Z])/g, '$1 $2')
            key = key.replace(/_/g, ' ')
            key = key.charAt(0).toUpperCase() + key.slice(1)
            return key
            // .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            // .join(' x ');
        },
        trackDelegate() {
            if(typeof window.clicky !== 'undefined') {
                window.clicky.log('/validators/details/delegate')
            }
        },
        getBadgeType(flag) {
            const dangerFlags = [
                'excessive_commission',
                'high_stake_concentration',
                'extreme_data_center_concentration',
                'admin_warning'
            ];
            if (flag === 'JITO_MEV') return 'bg-success';

            return dangerFlags.includes(flag) ? 'bg-danger' : 'bg-warning';
        },

        icon(flag) {
            if(flag === 'JITO_MEV') return 'fas fa-bolt bg-white'
            return 'fas fa-exclamation-triangle bg-white'
        }
    }
}
</script>

<style scoped>
.dark-mode h1 {
    font-size: 1.7rem;
}

.pagination li button.page-link {
    color: #f0f0f0 !important;
    background-color: #343a40 !important;

}
</style>
